import { render, staticRenderFns } from "./TransmittedSettlement.vue?vue&type=template&id=ef1d5512"
import script from "./TransmittedSettlement.vue?vue&type=script&lang=js"
export * from "./TransmittedSettlement.vue?vue&type=script&lang=js"
import style0 from "./TransmittedSettlement.vue?vue&type=style&index=0&id=ef1d5512&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports